import firebase from 'firebase/app';
import { useEffect } from 'react';
import { useRouter } from '../hooks/useRouter';
const { analytics } = firebase;

export const GoogleAnalyticsListener = ({ app }: { app: string }) => {
  const { location } = useRouter();
  const { pathname } = location;
  useEffect(() => {
    analytics().setCurrentScreen(pathname);
    analytics().logEvent('screen_view', {
      app_name: app,
      screen_name: pathname
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
};
